import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import Header from "./../../Header";
//import {ExecutionProgressBar} from "./ExecutionProgressBar";
import ModelSelector from "./ModelSelector";
import { RecentChats } from "./recentConversations";
import "../../assets/css/alie.css";

import MuviBrand from "../../assets/images/Muvi-Brand-Icon-Blue.svg"

import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import moment from 'moment';

import AlieLogo from "./icons/Alie-White.svg";
import AIAgentIcon from "./icons/Alieicon-White.png";
import sendBtn from "./icons/Send.svg";
import GoogleDocsIcon from "./icons/Google_Docs_Logo.svg";

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import 'highlight.js/styles/atom-one-dark.css';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Cookies from "js-cookie";

import { BsLayoutSidebar, BsLayoutSidebarInset } from "react-icons/bs";
import InteractionsModal from "../chat/components/InteractionsModal";
import { toast } from "react-toastify";


const CodeBlock = ({ node, inline, className, children, ...props }) => {
  const match = /language-(\w+)/.exec(className || '');
  const language = match ? match[1] : '';

  try {
    return !inline && match ? (
      <SyntaxHighlighter
        language={language}
        style={oneLight}
        PreTag="div"
        wrapLongLines={true}
        //preTagProps={{ className: 'alie-code-wrapper' }}
        customStyle={{
          background: 'transparent', // ✅ override theme background
          borderRadius: '6px',
          fontSize: '14px',
          padding: '1rem'
        }}
        className={'alie-code-wrapper'} // ✅ CORRECT
        {...props}
      >
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    );
  } catch (err) {
    console.warn(`⚠️ Unknown language: ${language}`, err);
    return (
      <pre className="hljs">
        <code>{children}</code>
      </pre>
    );
  }
};

const getFirstName = (fullName) => {

  if (!fullName) return null;

  // Split on both spaces and dots
  const parts = fullName.trim().split(/[\s.]+/);

  for (let part of parts) {
    // Skip initials (single characters)
    if (part.length > 1) {
      return part;
    }
  }

  return null; // fallback

};

const parseReferences = (rawReferences) => {
  if (Array.isArray(rawReferences)) return rawReferences;

  if (typeof rawReferences === "string") {
    try {
      const parsed = JSON.parse(rawReferences);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.warn("Failed to parse references:", rawReferences, err);
    }
  }
  return [];
};

const Alie = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [typingMessage, setTypingMessage] = useState(null);
  const chatContainerRef = useRef(null);
  const [conversationId, setConversationId] = useState(null);
  const [isReplay, setIsReplay] = useState(false);
  const [userUUID, setUserUUID] = useState(null);
  const [name, setUserName] = useState(null);
  const [permission, setUserPersmission] = useState([]);
  const [welcome, setWelcome] = useState('');
  const [recentReloadKey, setRecentReloadKey] = useState(0);
  const [openRefs, setOpenRefs] = useState({});
  const [provider, setProvider] = useState("google");
  const [isAlieSidebarVisible, setIsAlieSidebarVisible] = useState(true);
  const [showInteractionsModal, setShowInteractionsModal] = useState(false);
  const [selectedInteractionsId, setSelectedInteractionsId] = useState(null);
  const [shouldScroll, setShouldScroll] = useState(true);

  const DEFAULT_AGENT_ID = "alie-internal-001";
  const [agentId, setAgentId] = useState(DEFAULT_AGENT_ID);

  const toggleSidebar = () => {
    setIsAlieSidebarVisible(!isAlieSidebarVisible);
  };

  const handleSend = async () => {

    if (!input.trim()) return;

    const now = new Date();

    const timestamp = moment(now).format('hh:mm A');

    console.log('timestamp', timestamp);

    const created_date = new Date().toISOString();

    setMessages((prev) => [...prev, { type: "user", text: input, time: timestamp, created_date: created_date, conversation_id: conversationId }]);
    setInput("");
    setLoading(true);
    setTypingMessage({ type: "bot", showIcon: true, time: timestamp });

    try {

      const response = await fetch(`${process.env.REACT_APP_CRM}/ai/ask`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: input,
          provider,
          agent: agentId,
          user_uuid: userUUID,
          conversation_id: conversationId,
        }),
      });

      // const reader = response.body.getReader();
      // const decoder = new TextDecoder();

      const data = await response.json();

      console.log("data", data);

      const botMessage = data.text || "I'm sorry, I wasn't able to generate a response right now. Please try again in a moment.";

      const references = data.sources || [];
      const created_date = data.created_date || new Date().toISOString();

      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          text: botMessage,
          references: references,
          time: timestamp,
          created_date: created_date,
          conversation_id: conversationId,
          interaction_id: data.interaction_id || null,
          _id: data.bot_message_id || null,
        },
      ]);

      setRecentReloadKey(prev => prev + 1);

      setTypingMessage(null);

      // setMessages((prev) => [...prev, { type: "bot", text: botMessage.trim(), time: timestamp }]);
      // setTypingMessage(null);
    } catch (error) {
      console.error("LLM stream error:", error);
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "I'm sorry, I encountered a technical issue. Please try again in a few seconds.", time: timestamp, conversation_id: conversationId, created_date: created_date },
      ]);
      setTypingMessage(null);
    }
    setLoading(false);

  };

  useEffect(() => {
    if (!userUUID) return;

    const params = new URLSearchParams(window.location.search);
    const idFromUrl = params.get("conversation_id");

    if (idFromUrl) {
      setConversationId(idFromUrl);

      console.log('conversation_id', idFromUrl);

      fetchMessages(idFromUrl, userUUID); // Load existing messages

    } else {
      const newId = generateConversationId();
      setConversationId(newId);
    }
  }, [userUUID]);

  useEffect(() => {
    if (chatContainerRef.current && shouldScroll) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages, typingMessage]);

  // useEffect(() => {
  //   if (messages.length === 0 || isReplay) return;

  //   const lastMessage = messages[messages.length - 1];

  //   if (messages.length > 0) {
  //     //get the first message and store it as title
  //     const firstMessage = messages[0].text;
  //     lastMessage.conversation_title = firstMessage.slice(0, 50);
  //     lastMessage.user_uuid = userUUID;
  //   }

  // }, [messages]);



  const opennewTab = {
    a: ({ node, ...props }) => (
      <a {...props} target="_blank" rel="noopener noreferrer" />
    )
  };


  const generateConversationId = () => {
    const timestamp = Date.now().toString(36); // base36 timestamp
    const random = Math.random().toString(36).substring(2, 10); // random string
    return `conv_${timestamp}_${random}`;
  };

  const fetchMessages = async (conversation_id, user_uuid) => {
    try {
      if (!user_uuid) return;

      setConversationId(conversation_id);

      const res = await fetch(
        `${process.env.REACT_APP_CRM}/ai/conversations/get?conversation_id=${conversation_id}&user_uuid=${user_uuid}`
      );

      const result = await res.json();

      const data = result.data || [];

      console.log('data', data);

      if (Array.isArray(data)) {

        window.history.replaceState(null, '', `?conversation_id=${conversation_id}`);

        // const parsedMessages = data.map((msg) => ({
        //   ...msg,
        //   text: msg.text || '',
        //   references: msg.references || '',
        // }));

        const parsedMessages = data.map((msg) => ({
          ...msg,
          text: msg.text || '',
          references: parseReferences(msg.references),
        }));

        console.log('parsedMessage', parsedMessages);

        setIsReplay(true);
        setMessages(parsedMessages);

        setTimeout(() => {
          setIsReplay(false);
        }, 0);

        // Here get the last data to set the agent id
        if (data.length > 0) {
          const lastMsg = data[data.length - 1];

          console.log('lastMsg', lastMsg.agent_id);
          
          if (lastMsg.agent_id) {
            setAgentId(lastMsg.agent_id);
          }
        }
      }
    } catch (err) {
      console.error("Error fetching conversation:", err);
    }
  };

  const handleNewMessage = () => {
    if (messages.length === 0) return; // Prevent click if chat is empty
    const newId = generateConversationId();
    setConversationId(newId);
    setMessages([]);
    window.history.replaceState(null, '', `?conversation_id=${newId}`);
  };

  const toggleReferences = (id) => {
    setOpenRefs(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    getUserUUID();
  }, []);

  const getUserUUID = () => {

    const userdetails = decrypt(localStorage.getItem("encdata"), 0);

    //console.log('userdetails',userdetails);

    let uuid;
    const cookieUuid = Cookies.get("muvi_useruuid");
    if (cookieUuid) {
      uuid = cookieUuid;
    } else {
      //uuid = userdetails?.user_uuid || null;
      uuid = (userdetails && userdetails.user_uuid) ? userdetails.user_uuid : null;
    }

    setUserUUID(uuid);

    const full_name = (userdetails && userdetails.user_name) ? userdetails.user_name : null;

    const name = getFirstName(full_name);

    setUserName(name);

    //console.log('name', name);

    const storedPermission = localStorage.getItem("user_permission");
    //user permission is comma separated integer values, we need to parse it
    console.log('setUserPermission', storedPermission);
    if (storedPermission) {
      // Split and normalize as strings (["1", "2", ...])
      console.log('permission', storedPermission.split(","));

      setUserPersmission(storedPermission.split(","));
    } else {
      // Default to string "1" to keep consistent data type
      setUserPersmission(["1"]);
    }

    const welcomeMessages = [
      "What would you like to ask?",
      "Need any help?",
      "What's the plan?",
      "What’s on your mind?",
      "How can I assist you?",
      "Got something for me?",
      "What’s your question?",
      "What can I do for you?",
      "What’s your query?",
    ];

    const randomIndex = Math.floor(Math.random() * welcomeMessages.length);

    setWelcome(welcomeMessages[randomIndex]);
  };

  const decrypt = (findresponse, flg) => {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  };

  const greeting = (() => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) return 'Good morning';
    if (hour >= 12 && hour < 17) return 'Good afternoon';
    if (hour >= 17 && hour < 22) return 'Good evening';
    return 'Good night';
  })();

  const addReactionToMessage = (message_id, reaction) => {
    setShouldScroll(false);
    const body = JSON.stringify({
      "message_id": message_id,
      "reaction": reaction,
      "conversation_id": conversationId,
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    };

    fetch(`${process.env.REACT_APP_CRM}/ai/message/reaction`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log('Reaction response:', result);
        if (result.success == true) {
          const updatedMessages = messages.map(msg => {
            if (msg._id === message_id) {
              return { ...msg, reaction: reaction };
            }
            return msg;
          });
          setMessages(updatedMessages);
        } else {
          console.log("Failed to record reaction. Please try again.");
        }
      })
      .catch(error => {
        console.log("Failed to record reaction. Please try again.");
      })
      .finally(() => {
        setShouldScroll(true);
      });
  };

  return (
    <div>
      <Header brecum_name="AI" brecum_page="Ask" />
      <div class="right_col aliechatarea">
        <div className={`alie-chat-area ${isAlieSidebarVisible ? "" : "conv_collapsed"}`} id="full-chat-area">

          <div className={`alie-left ${isAlieSidebarVisible ? "d-none" : ""}`}>
            {userUUID && (
              <RecentChats
                user_uuid={userUUID}
                fetchMessages={fetchMessages}
                reloadTrigger={recentReloadKey}
                selectedconversationId={conversationId}
              />
            )}
            <div className="train-area">

              {permission && permission.includes("16") && (
                <Link to="/train" className="btn btn-block btn-train" style={{ width: "80%" }}>
                  <i class='far fa-comment'></i> Train Alie
                </Link>
              )}

            </div>
          </div>

          <div className={`alie-middle ${messages.length > 0 ? 'has-messages' : 'no-messages'}`} id="full-chat-middle">


            <div class="topbar">
              <div class="leftone">
                <button className="alie-toggle-btn" onClick={toggleSidebar}>
                  {isAlieSidebarVisible ? <BsLayoutSidebar /> : <BsLayoutSidebarInset />}
                </button>
                {messages.length > 0 && (
                  <div class="model-selector">
                    <span className="AlieHeading">Ask Alie</span>

                    <ModelSelector
                      agentId={agentId}
                      onChange={(id) => {
                        setAgentId(id);
                      }}
                    />
                  </div>
                )}
              </div>
              <div class="rightone">
                {messages.length > 0 && (
                  <div class="inner-rightone" id="innerRightone">
                    <button
                      type="button"
                      onClick={handleNewMessage}
                      disabled={messages.length === 0}
                      className={`btn btn-sky mob ${messages.length === 0 ? 'disabled' : ''}`}
                    >
                      <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;Start New Chat
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="alie-container">
              {messages.length === 0 ? (
                <div className="empty-chat">
                  <div className="alielogo">
                    <img src={AlieLogo} alt="Alie" />
                  </div>
                  <div className="greetings">{greeting} {name}!</div>
                  <div className="question">{welcome}</div>
                </div>
              ) : (
                <div className="midle-full-chatbox alie-response" ref={chatContainerRef}>
                  <div className="chat-body">
                    {messages.map((msg, index) => {
                      return (
                        <div
                          key={index}
                          className={`answer ${msg.type === "user" ? "right" : "left"}`}
                        >
                          <div className="avatar">
                            <img
                              src={
                                msg.type === "user"
                                  ? `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&color=ff0000&size=24&background=363946`
                                  : AIAgentIcon
                              }
                              alt={msg.type === "user" ? name : "Bot"}
                            />
                            <div className="status offline"></div>
                          </div>

                          <div className="text" id={msg.interaction_id || ""}>
                            {msg.type === "bot" ? (
                              <div>
                                <div className="markdown-body">
                                  <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={{
                                      code: CodeBlock,
                                      ...opennewTab
                                    }}
                                  >
                                    {msg.text}
                                  </ReactMarkdown>
                                </div>
                              </div>
                            ) : (
                              <div className="mssg-text">{msg.text}</div>
                            )}

                            {
                              msg.type == "bot" && (
                                <div className="bot-info">
                                  <div className="bot-reaction-buttons">
                                    <button
                                      className={`Good ${msg.reaction == 1 ? 'selected' : ''}`}
                                      onClick={() => addReactionToMessage(msg._id, msg.reaction == 1 ? 0 : 1)}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up" viewBox="0 0 16 16">
                                        <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"/>
                                      </svg>
                                    </button>
                                    <button
                                      className={`Bad ${msg.reaction == 2 ? 'selected' : ''}`}
                                      onClick={() => addReactionToMessage(msg._id, msg.reaction == 2 ? 0 : 2)}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-down" viewBox="0 0 16 16">
                                        <path d="M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856s-.036.586-.113.856c-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a10 10 0 0 1-.443-.05 9.36 9.36 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a9 9 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581s-.027-.414-.075-.581c-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.2 2.2 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.9.9 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1"/>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="bot-info-interactions">
                                    {msg.references && msg.references.length > 0 && (
                                      <div style={{ cursor: "pointer" }}>
                                        <div onClick={() => toggleReferences(index)} style={{ cursor: "pointer" }}>
                                          Source
                                          <i
                                            className={`fa fa-caret-${openRefs[index] ? "up" : "down"}`}
                                            style={{ marginLeft: "5px" }}
                                          ></i>
                                        </div>
                                      </div>
                                    )}
                                    {
                                      msg.interaction_id && (
                                        <div
                                          className="interactions-button"
                                          onClick={() => {
                                            setSelectedInteractionsId(msg.interaction_id);
                                            setShowInteractionsModal(true);
                                          }}
                                          title="View Interactions"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 50 50">
                                            <path d="M49.04,24.001l-1.082-0.043h-0.001C36.134,23.492,26.508,13.866,26.042,2.043L25.999,0.96C25.978,0.424,25.537,0,25,0	s-0.978,0.424-0.999,0.96l-0.043,1.083C23.492,13.866,13.866,23.492,2.042,23.958L0.96,24.001C0.424,24.022,0,24.463,0,25	c0,0.537,0.424,0.978,0.961,0.999l1.082,0.042c11.823,0.467,21.449,10.093,21.915,21.916l0.043,1.083C24.022,49.576,24.463,50,25,50	s0.978-0.424,0.999-0.96l0.043-1.083c0.466-11.823,10.092-21.449,21.915-21.916l1.082-0.042C49.576,25.978,50,25.537,50,25	C50,24.463,49.576,24.022,49.04,24.001z"></path>
                                          </svg>
                                        </div>
                                      )
                                    }
                                  </div>
                                  {/* <div className="spacer"></div>
                                      <div className="time">{msg.time}</div> */}
                                </div>
                              )
                            }


                            {Array.isArray(msg.references) && msg.references.length > 0 && (
                              <div
                                className={`collapse ${openRefs[index] ? "in" : ""}`}
                                style={{ marginLeft: "15px", marginTop: "5px" }}
                              >
                                <div className="row">
                                  {msg.references.map((ref, i) => (
                                    <div key={i}>
                                      <div className="references h-100 shadow-sm">
                                        <a
                                          href={
                                            ref.section
                                              ? `${ref.document_url}#:~:text=${encodeURIComponent(ref.section)}`
                                              : ref.document_url
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <div className="ref-body">

                                            <h5 className="ref-title">
                                              {ref.document_url && ref.document_url.includes("docs.google")
                                                ? <img src={GoogleDocsIcon} alt="Google" height="14px" />
                                                : <img src={MuviBrand} alt="Muvi" />}
                                              {ref.document_title && ref.document_title.length > 75
                                                ? ref.document_title.slice(0, 75) + "..."
                                                : ref.document_title || "Untitled Document"}
                                            </h5>

                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {typingMessage && (
                      <div className="answer left">
                        <div className="avatar">
                          <img src={AIAgentIcon} alt="Bot" />
                          <div className="status offline"></div>
                        </div>
                        {typingMessage.showIcon ? (
                          <div className="message-gif">
                            <div className="dot-flashing"></div>
                          </div>
                        ) : (
                          <div className="text">
                            <div className="markdown-body">
                              <ReactMarkdown plugins={[remarkGfm]}>
                                {typingMessage.text}
                              </ReactMarkdown>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="chat-box">
                <div class="type_msg">
                  <div class="chat-input">
                    <textarea
                      type="text"
                      className="write_msg"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      placeholder="Ask something..."
                      onKeyPress={(e) => e.key === "Enter" && handleSend()}
                    />
                    <button class="btn msg_send_btn" type="button" onClick={handleSend} disabled={loading}>
                      <img src={sendBtn} alt="send" height="30px" />
                    </button>
                  </div>
                </div>

              </div>

            </div>

          </div>
          <InteractionsModal
            interactionId={selectedInteractionsId}
            showModal={showInteractionsModal}
            setShowModal={setShowInteractionsModal}
          />
        </div>
      </div>
    </div>
  );
};

export default Alie;


// WEBPACK FOOTER //
// ./src/components/ai/ai.js